import AmandaSternResume from './AmandaSternResume.pdf'

const amandaResume = {
  src: AmandaSternResume,
  altText: 'Amanda Stern one-page resume'
}

export {
  amandaResume,
}